import React from 'react';
import classNames from 'classnames';
import './index.scss';

import getSectionItemEditComponent from '../SectionItemEdit/SectionItemEditComponent';

const SectionItemEditControl = ({ id, column, item, onPropChange }) => {
  const ControlItem = getSectionItemEditComponent(column.type, column.connect, item);
  const handleOnPropChange = value => {
    if(column.isReadonly) {
      return;
    }
    onPropChange({ ...item, ...value });
  };

  return (
    <div className={classNames('sectionItemEditControl')}>
      <ControlItem
        key={`sectionItemEditControl-${item.id || ''}${column.accessor}-${column.type}`}
        id={id}
        column={{ ...column, title: column.controlTitle }}
        item={item}
        value={item[column.accessor]}
        model={null}
        onPropChange={handleOnPropChange}
      />
    </div>
  );
};

export default SectionItemEditControl;
